export const buildFieldNameFieldArray = (fieldArrayName, fieldName, idx) => {
  return `${fieldArrayName}.${idx}.${fieldName}`;
};
